export default __webpack_public_path__ + "static/media/man-dog.e141fc14.jpg";